import type { DeviceGroupFilter } from "./devices.const";
import type { ApiDevice } from "../_types/devices.types";

/** Client-side grouping only; device type and status use API query params. */
export const filterDevicesList = (devices: ApiDevice[], group: DeviceGroupFilter): ApiDevice[] => {
  return devices.filter((device) => {
    if (group === "ungrouped" && device.organization && device.organization.trim().length > 0) {
      return false;
    }
    return true;
  });
};
